// Uses the start/upload/finish protocol shared with FileController.
export default async function uploadChunks(client, url, image, metadata, onProgress = () => {}) {
    if (!image.size || image.size > 100 * 1024 * 1024) {
        throw new Error('Bilden måste vara större än 0 byte och högst 100 MB.');
    }
    const start = await client.post(url, {
        ...metadata, phase: 'start', name: 'greeting.png', mime_type: image.type, size: image.size,
    });
    const { session_id: sessionId, end_offset: chunkSize } = start.data.data;
    if (!sessionId || !Number.isInteger(chunkSize) || chunkSize <= 0) throw new Error('Servern kunde inte starta uppladdningen.');
    onProgress(0);
    for (let offset = 0; offset < image.size; offset += chunkSize) {
        const form = new FormData();
        form.append('phase', 'upload');
        form.append('session_id', sessionId);
        form.append('start_offset', offset);
        form.append('chunk', image.slice(offset, offset + chunkSize), 'chunk');
        // Retrying a chunk is safe: the server checks already received bytes.
        for (let attempt = 0; ; attempt += 1) {
            try {
                // eslint-disable-next-line no-await-in-loop
                await client.post(url, form);
                break;
            } catch (error) {
                if (attempt >= 2 || (error.response && error.response.status < 500)) throw error;
            }
        }
        onProgress(Math.round((Math.min(offset + chunkSize, image.size) / image.size) * 100));
    }
    // Publication changes the order; never automatically repeat this request.
    return client.post(url, { phase: 'finish', session_id: sessionId });
}
